export default {
      path: '/lvy-new-guide',
      component: () => import('./LVYNewGuide'),
      meta: {
        title: '新手引导',
        designWidth:750,
        expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (GMT+08:00)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
